import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const PlasticWrap = forwardRef<SVGSVGElement, Partial<IconProps>>(function PlasticWrap({
  styles,
  ...props
}, ref) {
  return <Icon title="Plastic Wrap Icon" description="A publication in plastic wrap for postage" ref={ref} {...stylex.props(styles)} viewBox="0 0 36 36" {...props}>
        <path {...stylex.props(iconsStyles.lightElement)} d="M9.6 3.8c-1.5.1-2.7 1-2.9 2.4a141.3 141.3 0 0 0-.4 23c.2 1.6 1.6 2.9 3.5 3a98 98 0 0 0 16.4 0c2-.1 3.3-1.4 3.5-3a141.2 141.2 0 0 0 0-22.4c-.2-1.6-1.6-2.9-3.5-3a98 98 0 0 0-16.6 0Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M20.7 8s1.2.5 3.5 2.8a12 12 0 0 1 2.7 3.4 74 74 0 0 1-.5 12c-.1.9-.8 1.4-1.7 1.5a65.2 65.2 0 0 1-13.4 0c-1 0-1.6-.6-1.7-1.5-.3-1.4-.6-3.9-.6-8.2 0-4.3.3-6.8.6-8.2.1-.9.8-1.4 1.7-1.5a65.3 65.3 0 0 1 9.4-.3Z" />
        <path {...stylex.props(iconsStyles.primaryElement)} d="M21.2 8.3c.5.3 1.5 1 3 2.4a12 12 0 0 1 2.7 3.6c-1.3.3-2.8.2-4.1-.2a2 2 0 0 1-1.3-1.3 9 9 0 0 1-.3-4.5Z" />
      </Icon>;
});